import type { CartItem, CartProduct, ShopProduct } from "./types";

export type CartBlockReason = "out_of_stock" | "missing_price";

export function getCartBlockReason(product: Pick<ShopProduct, "priceRub" | "stock">): CartBlockReason | null {
  if (product.stock !== null && product.stock !== undefined && product.stock <= 0) return "out_of_stock";
  if (product.priceRub === null || product.priceRub === undefined || product.priceRub <= 0) return "missing_price";
  return null;
}

export function toCartProduct(product: ShopProduct): CartProduct {
  return {
    id: product.id,
    name: product.name,
    article: product.article,
    priceRub: product.priceRub,
  };
}

export function addCartItem(cart: CartItem[], item: CartProduct): CartItem[] {
  const existing = cart.find((cartItem) => cartItem.id === item.id);
  if (!existing) return [...cart, { ...item, qty: 1 }];
  return cart.map((cartItem) => cartItem.id === item.id
    ? { ...cartItem, qty: Math.max(1, Number(cartItem.qty) || 1) + 1 }
    : cartItem);
}

export function changeCartItemQuantity(cart: CartItem[], itemId: string, change: number): CartItem[] {
  return cart.flatMap((item) => {
    if (item.id !== itemId) return [item];

    const nextQuantity = Math.max(0, (Number(item.qty) || 0) + change);
    return nextQuantity > 0 ? [{ ...item, qty: nextQuantity }] : [];
  });
}

export function cartItemCount(cart: { qty?: unknown }[]) {
  return cart.reduce((sum, item) => sum + Math.max(0, Number(item.qty) || 0), 0);
}
